module.exports = __webpack_public_path__ + "static/media/women_kit.c028358c.png";